export default {"src":"/_next/static/media/pilResurs13303.e6a16e2c.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};